




































import Vue from 'vue';

export default Vue.extend({
    props: {
        standerTableList: { type: Array },
    },
    created() {
        console.log(this.standerTableList);
    },
});
